import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'select2'; // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';
import 'select2/dist/js/i18n/fr.js';

export default {
  init() {
    // function showActiveTab() {
    //   var btn = $('.nav .nav-link.active');
    //   var tab = btn.data('tab');
    //   $('section[data-tab]').hide();
    //   $(`section[data-tab=${tab}]`).show();
    // }

    // showActiveTab();

    // $(document).on('click', '.nav .nav-link', function () {
    //   $('.nav .nav-link').removeClass('active');
    //   $(this).addClass('active');
    //   showActiveTab();
    // });
  },
  finalize() {
    moment.locale('fr');
    $('#salle_id').select2({
      placeholder: 'Sélectionnez une salle',
      language: 'fr',
    });

    $('#salle_id').on('select2:open', function () { 
      $('#salle_id select2-search input').attr('placeholder', 'Recherche');
      $('#salle_id select2-search input').attr('focus', true);
    });


    // eslint-disable-next-line no-unused-vars
    function showCouleur(couleur) {
      return `<span style='display: block; width: 20px; height: 20px; min-width: 20px; min-height: 20px; background-color: ${couleur}; margin-left: 0.5rem;'></span>`;
    }

    // eslint-disable-next-line no-unused-vars
    function formatDateToString(date) {
      // 01, 02, 03, ... 29, 30, 31
      var dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
      // 01, 02, 03, ... 10, 11, 12
      var MM = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
      // 1970, 1971, ... 2015, 2016, ...
      var yyyy = date.getFullYear();

      // create the format you want
      return yyyy + '-' + MM + '-' + dd;
    }

    function generateCalendar(d) {
      $('#calendar table').html('');
      Date.prototype.monthDays = function () {
        var d = new Date(this.getFullYear(), this.getMonth() + 1, 0);
        return d.getDate();
      };
      Date.prototype.lastMonthDays = function () {
        var d = new Date(this.getFullYear(), this.getMonth(), 0);
        return d.getDate();
      };
      var details = {
        totalLastDays: d.lastMonthDays(),
        totalDays: d.monthDays(),
        weekDays: [
          'Lundi',
          'Mardi',
          'Mercredi',
          'Jeudi',
          'Vendredi',
          'Samedi',
          'Dimanche',
        ],
        weekDaysMobile: [
          'Lun.',
          'Mar.',
          'Mer.',
          'Jeu.',
          'Ven.',
          'Sam.',
          'Dim',
        ],
        months: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ],
      };
      var start = new Date(d.getFullYear(), d.getMonth()).getDay();
      // Le jour 0 correspond au Dimanche, on tranforme pour avoir 0 = lundi
      start -= 1;
      if (start < 0) {
        start = 6;
      }
      var cal = [];
      var day = 1;
      var end = false;

      // Ligne
      for (var i = 0; i <= 6; i++) {
        cal.push(['<tr>']);
        // Colonne / jour (de lun à dim)
        for (var j = 0; j <= 6; j++) {
          if (j === 6) {
            day++;
            continue;
          }
          // Première ligne => Header
          if (i === 0) {
            cal[i].push(
              `<td><span class="desktop">${details.weekDays[j]}</span><span class="mobile">${details.weekDaysMobile[j]}</span></td>`
            );
          } else if (day > details.totalDays) {
            if (!end) {
              cal[i].push(
                `<td class="disabled">${day++ - details.totalDays}</td>`
              );
            } else {
              cal[i].push('<td class="disabled">&nbsp;</td>');
            }
            if (j === 6) {
              end = true;
            }
          } else {
            if (i === 1 && j < start) {
              cal[i].push(
                `<td class="disabled">${
                  details.totalLastDays - (start - 1 - j)
                }</td>`
              );
            } else {
              var date = new Date(d.getFullYear(), d.getMonth(), day);
              var same = moment(date).isSame(
                agenda.currentData.currentDate,
                'day'
              );
              var classes = 'day';
              if (same) {
                classes = 'day active';
              }
              cal[i].push(
                `<td class="${classes}" data-date="${d.getFullYear()}-${(
                  date.getMonth() + 1
                )
                  .toString()
                  .padStart(2, '0')}-${day
                  .toString()
                  .padStart(2, '0')}"><div><span>${day++}</span></div></td>`
              );
            }
          }
        }
        cal[i].push('</tr>');
      }
      cal = cal
        .reduce(function (a, b) {
          return a.concat(b);
        }, [])
        .join('');
      $('#calendar table').append(cal);
      $('#calendar #month').text(details.months[d.getMonth()]);
      $('#calendar #year').text(d.getFullYear());
      $('#calendar td.day').on('click', function () {
        $('#calendar td.day.active').removeClass('active');
        $(this).addClass('active');
        agenda.gotoDate($(this).data('date'));
      });
    }

    // eslint-disable-next-line no-unused-vars
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
    
    var salle_id = document.getElementById('salle_id').value;
    var salle_nom = $('#salle_id option:selected').text();
    var user_id = null;
    if ($('#user_id').length) {
      user_id = document.getElementById('user_id').value;
    }
    var currentDate = new Date();

    $('#calendar #left').on('click', function () {
      if (currentDate.getMonth() === 0) {
        currentDate = new Date(currentDate.getFullYear() - 1, 11);
        generateCalendar(currentDate);
      } else {
        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1
        );
        generateCalendar(currentDate);
      }
    });
    $('#calendar #right').on('click', function () {
      if (currentDate.getMonth() === 11) {
        currentDate = new Date(currentDate.getFullYear() + 1, 0);
        generateCalendar(currentDate);
      } else {
        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1
        );
        generateCalendar(currentDate);
      }
    });

    var agendaElmt = document.getElementById('agenda');
    var agenda = new Calendar(agendaElmt, {
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
      initialView: 'timeGridWeek',
      locale: frLocale,
      selectable: true,
      allDaySlot: false,
      editable: false,
      nowIndicator: true,
      slotMinTime: '08:00:00',
      slotMaxTime: '19:00:00',
      slotDuration: '00:15:00',
      expandRows: true,
      timeZone: 'Europe/Paris',
      longPressDelay: 500,
      hiddenDays: [ 0 ],
      eventSources: [
        {
          // eslint-disable-next-line no-undef
          url: ajax_object.ajaxurl,
          method: 'POST',
          extraParams: function () {
            return {
              action: 'get_dashboard',
              salle_id: salle_id,
            };
          },
          failure: function () {
            console.error('Erreur lors de la récupération des événements');
          },
          color: '#57DBE6',
          textColor: 'white',
          defaultAllDay: false,
        },
      ],
      datesSet: function (view) {
        currentDate = view.view.calendar.currentData.currentDate;
        generateCalendar(currentDate);
      },
      dayHeaderContent: function (info) {
        var date = moment(info.date).format('ddd D');
        return {
          html: `<div class="day desktop">${info.text}</div><div class="day mobile">${date}</div>`,
        };
      },
      eventClick: function(info) {
        var reservation_id = info.event.id;
        $.ajax({
          type: 'POST',
          // eslint-disable-next-line no-undef
          url: ajax_object.ajaxurl,
          beforeSend: function () {
            Toast.fire({
              icon: 'info',
              title: `Chargement de la réservation n°${info.event.id} en cours`,
              timer: false,
            });
          },
          data: {
            action: 'get_reservation_infos',
            reservation_id: reservation_id,
          },
          success: function (response) {
            if (response.success) {
              var date = '';
              if (moment(info.event.startStr).isSame(info.event.endStr, 'day')) {
                date = `le ${moment(info.event.startStr).format('D/MM')} de ${moment(info.event.startStr).format('HH:mm')} à ${moment(info.event.endStr).format('HH:mm')}`;
              }
              else {
                date = `du ${moment(info.event.startStr).format('D/MM à HH:mm')} au ${moment(info.event.endStr).format('D/MM à HH:mm')}`;
              }
              if (user_id) {
                Swal.fire({
                  title: `Réservation de ${response.salle.nom} ${date}`,
                  html: response.html,
                  showDenyButton: true,
                  showCancelButton: true,
                  showConfirmButton: false,
                  denyButtonText: 'Supprimer',
                  cancelButtonText: 'Fermer',
                }).then((infos) => {
                  if (infos.isDenied) {
                    $.ajax({
                      type: 'POST',
                      // eslint-disable-next-line no-undef
                      url: ajax_object.ajaxurl,
                      data: {
                        // eslint-disable-next-line no-undef
                        security_delete_reservation: ajax_object.ajax_nonce,
                        action: 'delete_reservation',
                        reservation: reservation_id,
                      },
                      success: function (response_delete) {
                        if (response_delete.success) {
                          agenda.refetchEvents();
                          Toast.fire({
                            icon: 'success',
                            title: 'Réservation supprimée',
                          });
                        } else {
                          Toast.fire({
                            icon: 'error',
                            title: `${response_delete.message}`,
                          });
                        }
                      },
                    });
                  }
                });
              }
              else {
                Swal.fire({
                  title: `Réservation de ${response.salle.nom} ${date}`,
                  html: response.html,
                  showCancelButton: true,
                  showConfirmButton: false,
                  cancelButtonText: 'Fermer',
                });
              }
            } else {
              Toast.fire({
                icon: 'error',
                title: `${response.message}`,
              });
            }
          },
        });
      },
      select: function(info) {
        if (!salle_id || salle_id == 'all') {
          Swal.fire({
            title: 'Merci de sélectionner une salle avant de choisir un créneau',
            icon: 'error',
          });
          return false;
        }
        $.ajax({
          type: 'POST',
          // eslint-disable-next-line no-undef
          url: ajax_object.ajaxurl,
          beforeSend: function () {
            Toast.fire({
              icon: 'info',
              title: 'Chargement en cours',
              timer: false,
            });
          },
          data: {
            // eslint-disable-next-line no-undef
            security_add_reservation_form: ajax_object.ajax_nonce,
            action: 'add_reservation_form',
          },
          success: function (response_add) {
            if (response_add.success) {
              var date = '';
              if (moment(info.startStr).isSame(info.endStr, 'day')) {
                date = `le ${moment(info.startStr).format('D/MM')} de ${moment(
                  info.startStr
                ).format('HH:mm')} à ${moment(info.endStr).format('HH:mm')}`;
              } else {
                date = `du ${moment(info.startStr).format(
                  'D/MM à HH:mm'
                )} au ${moment(info.endStr).format('D/MM à HH:mm')}`;
              }
              Swal.fire({
                title: `Réservation de ${salle_nom} ${date}`,
                html: response_add.html,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: 'Réserver',
                cancelButtonText: 'Annuler',
                confirmButtonColor: '#2e7d32',
                preConfirm: () => {
                  $('#reservation_form').validate({
                    lang: 'fr',
                    rules: {
                      nom: {
                        required: true,
                      },
                      classe: {
                        required: true,
                      },
                      email: {
                        required: false,
                        email: true,
                      },
                      motif: {
                        required: true,
                      },
                    },
                    messages: {
                      nom: 'Saisir votre nom',
                      classe: 'Saisir votre prénom',
                      email: {
                        email:
                          'Saisir une adresse email valide (ex: email@exemple.com)',
                      },
                      motif: 'Saisir le motif de votre réservation',
                    },
                    errorElement: 'div',
                    errorPlacement: function (error, element) {
                      var placement = $(element).data('error');
                      if (placement) {
                        $(placement).append(error);
                      } else {
                        error.insertAfter(element);
                      }
                    },
                  });

                  if($('#reservation_form').valid()) {
                    return {
                      // eslint-disable-next-line no-undef
                      security_add_reservation: ajax_object.ajax_nonce,
                      action: 'add_reservation',
                      salle_id: salle_id,
                      start: info.startStr,
                      end: info.endStr,
                      motif: $('#motif').val(),
                      nom: $('#nom').val(),
                      classe: $('#classe').val(),
                      email: $('#email').val(),
                    };
                  }
                  else {
                    Swal.showValidationMessage('Merci de remplir les champs obligatoires');
                    return false;
                  }
                },
              }).then((infos) => {
                if (infos.isConfirmed) {
                  infos = infos.value;
                  $.ajax({
                    type: 'POST',
                    // eslint-disable-next-line no-undef
                    url: ajax_object.ajaxurl,
                    data: infos,
                    success: function (response) {
                      if (response.success) {
                        agenda.refetchEvents();
                        Toast.fire({
                          icon: 'success',
                          title: 'Réservation confirmée',
                        });
                      } else {
                        Toast.fire({
                          icon: 'error',
                          title: `${response.message}`,
                        });
                      }
                    },
                  });
                } else {
                  Toast.fire({
                    icon: 'warning',
                    title: 'Enregistrement annulé',
                  });
                }
              });
            } else {
              Toast.fire({
                icon: 'error',
                title: `${response_add.message}`,
              });
            }
          },
        });
      },
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
      },
      dayHeaderFormat: {
        weekday: 'long',
        day: 'numeric',
        omitCommas: true,
      },
      headerToolbar: {
        left: 'title',
        center: '',
        right: 'prev today next',
      },
    });

    agenda.render();

    $('#salle_id').on('change', function () {
      salle_id = $(this).val();
      salle_nom = $('#salle_id option:selected').text();
      agenda.refetchEvents();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/reservation_de_salle.js